import {Component, OnInit} from '@angular/core';
import {ApprovalsService} from '../approvals.service';
import {Subject} from 'rxjs';
import {ModalSize, SmartModalService} from '../../../../core/services/smart-modal.service';
import {CreateApprovalGroupComponent} from '../create-approval-group/create-approval-group.component';
import {NotificationService} from '../../../../core/services/notification.service';
import {CreateApprovalRuleComponent} from '../create-approval-rule/create-approval-rule.component';
import {SessionService} from '../../../../core/services/session.service';

@Component({
    selector: 'itpx-approved-rules',
    templateUrl: './approved-rules.component.html',
    styleUrls: ['approved-rules.component.css']
})
export class ApprovedRulesComponent implements OnInit {

    private approvedRulesListURL = null;
    private approvedRulesListRefresh = new Subject<any>();
    private approvedRulesListFields = [];
    private buyerCurrency : any = null;

    constructor(private approvalsService: ApprovalsService,
                private sessionService: SessionService,
                private modalService: SmartModalService,
                private notificationService: NotificationService) {

    }

    ngOnInit(): void {
        this.approvedRulesListURL = this.approvalsService.getApprovedRuleListUrl();
        this.approvalsService.fetchCurrencyForBuyer(this.sessionService.getUserDomain()).subscribe(_ => {
            this.buyerCurrency = _;
        });
        this.approvedRulesListFields = [
            {
                title: 'Rule Name',
                name: 'name'
            },
            {
                title: 'Rule Type',
                name: 'type.configValue'
            },
            {
                title: 'Value',
                name: (item) => {
                    return item.rules && item.rules.length && item.rules[0].value ? `${item.rules[0].value[0]} - ${item.rules[0].value[1]}` : '';
                }
            },
            {
                title: 'Send for Approval to',
                name: 'approvalGroup.name',
                config: {
                    type: 'template',
                    template: 'editApprovalGroup',
                }
            },
            {
                title: 'Action',
                name: '',
                config: {
                    type: 'template',
                    template: 'deleteRuleTmp',
                }
            }
        ];
    }

    createNewApprovedRule() {
        this.modalService.open(
            CreateApprovalRuleComponent,
            {
                ruleItem : null,
                newRule : true,
                buyerCurrency: this.buyerCurrency
            },
            'Create Approval Rule',
            ModalSize.Custom,
        )
        .neverError()
        .subscribe(_ => {
            if (_ && _.result) {
                this.notificationService.success('Rule successfully created');
                this.approvedRulesListRefresh.next(1);
            }
        });
    }

    editApprovedRule(rule) {
        this.modalService.open(
            CreateApprovalRuleComponent,
            {
                ruleItem : rule,
                buyerCurrency: this.buyerCurrency
            },
            'Edit Approval Rule',
            ModalSize.Custom,
        )
        .neverError()
        .subscribe(_ => {
            if (_ && _.result) {
                this.notificationService.success('Rule successfully updated');
                this.approvedRulesListRefresh.next(1);
            }
        });
    }

    createApprovalGroup() {
        this.modalService.open(
            CreateApprovalGroupComponent,
            {
                groupItem : null,
                newGroup : true,
                buyerCurrency: this.buyerCurrency
            },
            'Create Approval Group',
            ModalSize.Custom,
        )
        .neverError()
        .subscribe(_ => {
            if (_ && _.result) {
                this.notificationService.success('Group successfully created');
                this.approvedRulesListRefresh.next(1);
            }
        });
    }

    editApprovalGroupFn(item) {
        this.modalService.open(
            CreateApprovalGroupComponent,
            {
                groupItem : item,
                buyerCurrency: this.buyerCurrency
            },
            'Edit Approval Group',
            ModalSize.Custom,
        )
        .neverError()
        .subscribe(_ => {
            if (_ && _.result) {
                this.notificationService.success('Group successfully updated');
                this.approvedRulesListRefresh.next(1);
            }
        });
    }

    deleteApprovalRule(rule) {
        this.approvalsService.deleteApprovalRule(rule).subscribe(_ => {
            this.notificationService.success('Rule deleted successfully');
            this.approvedRulesListRefresh.next(1);
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/approved-rules/approved-rules.component.ts